export default __webpack_public_path__ + "static/media/seo-external-links.535548f3.svg";